// extracted by mini-css-extract-plugin
export var lg = "_1w-4";
export var md = "_1w-3";
export var sm = "_1w-2";
export var xs = "_1w-1";
export var xxs = "_1w-0";